import React, { useEffect, useState } from "react";
import { Modal, Box, Button, Typography, Alert } from "@mui/material";
import { getData } from "../../../services/library";
import EntrevistasItem from "./EntrevistasItem";
import EntrevistasForm from "./EntrevistasForm";
import ModalEntrevistaFechaHora from "./ModalEntrevistaFechaHora";
import { UrlApi } from "../../../services/apirest";
import { useNavigate } from "react-router-dom";

const Entrevistas = ({
  handleClose,
  rowInfo,
  puestoQueAplica,
  mostrarAlertaTemporal,
}) => {
  const navigate = useNavigate();
  const id_candidato = rowInfo.id;
  const [entrevistas, setEntrevistas] = useState([]);
  const [openFormModal, setOpenFormModal] = useState(false);

  //estados para agregar a entrevista
  const [fechaAgenda, setFechaAgenda] = useState(null);
  const [openModalAgendaEntrevista, setOpenModalAgendaEntrevista] =
    useState(false);

  //informacion del LS
  const USER = localStorage.getItem("user");
  const RRHH = localStorage.getItem("adminrrhh") === "1" ? 1 : 0;

  const searchEntrevistasPorCandidato = () => {
    getData(`/SP_entrevistas/${id_candidato}/${USER}/${RRHH}`, setEntrevistas);
  };

  useEffect(() => {
    searchEntrevistasPorCandidato();
  }, []);

  const handleOpenFormModal = () => {
    setOpenFormModal(true);
  };

  const agendarEntrevista = async (e) => {
    e.preventDefault();

    const id_solicitud = rowInfo.id_solicitud_a_aplicar;

    const nuevaEntrevista = {
      fecha_hora: fechaAgenda,
      id_candidato: id_candidato,
      id_solicitud: id_solicitud,
      user: USER,
    };

    const response = await fetch(`${UrlApi}/SP_proximas_entrevistas`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(nuevaEntrevista),
    });
    const { message, id } = await response.json(); //extraigo solo el mesnaje de la respuesta (por ahora tambien es lo unico que manda)

    if (response.ok) {
      mostrarAlertaTemporal(`${message} ID: ${id}`, "success");
    } else {
      mostrarAlertaTemporal(
        `Error al guardar la entrevista: ${message}`,
        "error"
      );
    }
  };

  return (
    <>
      {openModalAgendaEntrevista && (
        <ModalEntrevistaFechaHora
          setDate={setFechaAgenda}
          date={fechaAgenda}
          onClose={() => setOpenModalAgendaEntrevista(false)}
          open={openModalAgendaEntrevista}
          handleFunction={agendarEntrevista}
        />
      )}
      {openFormModal && (
        <EntrevistasForm
          isEditMode={false}
          onClose={() => setOpenFormModal(false)}
          obtenerEntrevistas={searchEntrevistasPorCandidato}
          mostrarAlertaTemporal={mostrarAlertaTemporal}
          idCandidato={id_candidato}
          puestoQueAplica={puestoQueAplica}
        />
      )}

      <Modal
        open={true}
        onClose={handleClose}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 1000,
            maxHeight: 700,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            borderRadius: 2,
            margin: "auto",
          }}
        >
          {entrevistas.length === 0 ? (
            <>
              <Typography variant="h6" id="modal-title" sx={{ mb: 2 }}>
                No hay entrevistas
              </Typography>
              <div sx={{ display: "flex", gap: 6, flexDirection: "row" }}>
                <Button
                  variant="contained"
                  color="primary"
                  sx={{ m: 2 }}
                  onClick={handleOpenFormModal}
                >
                  Agregar Entrevista
                </Button>
                <Button
                  variant="contained"
                  color="success"
                  onClick={() => setOpenModalAgendaEntrevista(true)}
                  sx={{ m: 2 }}
                  // onClick={handleOpenFormModal}
                >
                  Agendar Entrevista
                </Button>
                {RRHH === 1 && (
                  <Button
                    variant="contained"
                    sx={{
                      m: 2,
                      backgroundColor: "#368dff",
                      "&:hover": {
                        backgroundColor: "#006eff",
                      },
                    }}
                    onClick={() => navigate("/SP_proximas_entrevistas")}
                  >
                    Apartado de futuras entrevistas
                  </Button>
                )}
              </div>
            </>
          ) : (
            <>
              <Typography variant="h6" id="modal-title" sx={{ mb: 2 }}>
                Entrevistas
              </Typography>
              <div sx={{ display: "flex", gap: 6, flexDirection: "row" }}>
                <Button
                  variant="contained"
                  color="primary"
                  sx={{ m: 2 }}
                  onClick={handleOpenFormModal}
                >
                  Agregar Entrevista
                </Button>
                <Button
                  variant="contained"
                  color="success"
                  sx={{ m: 2 }}
                  onClick={() => setOpenModalAgendaEntrevista(true)}

                  // onClick={handleOpenFormModal}
                >
                  Agendar Entrevista
                </Button>
                {RRHH === 1 && (
                  <Button
                    variant="contained"
                    sx={{
                      m: 2,
                      backgroundColor: "#7369ff",
                      "&:hover": {
                        backgroundColor: "#5b4fff",
                      },
                    }}
                    onClick={() => navigate("/SP_proximas_entrevistas")}
                  >
                    Apartado de futuras entrevistas
                  </Button>
                )}
              </div>
              {/* Contenedor scrollable para la lista de entrevistas */}
              <Box
                sx={{
                  width: "100%",
                  maxHeight: 500,
                  overflowY: "auto",
                  padding: 2,
                  border: "1px solid #ccc",
                  borderRadius: 1,
                }}
              >
                {entrevistas.map((entrevista) => (
                  <EntrevistasItem
                    key={entrevista.id}
                    id={entrevista.id}
                    id_entrevistador={entrevista.id_entrevistador}
                    id_candidato={entrevista.id_candidato}
                    nombre_candidato={entrevista.nombre_candidato}
                    apellido_candidato={entrevista.apellido_candidato}
                    trabajo_candidato={entrevista.trabajo_candidato}
                    dni_contacto={entrevista.dni_contacto}
                    edad_candidato={entrevista.edad_candidato}
                    telefono_candidato={entrevista.telefono_candidato}
                    nombre_entrevistador={entrevista.nombre_entrevistador}
                    apellido_entrevistador={entrevista.apellido_entrevistador}
                    fecha_entrevista={entrevista.fecha_entrevista}
                    aprobado={entrevista.aprobado}
                    observacion={entrevista.observacion}
                    linit_vigente={entrevista.linit_vigente}
                    caducidad_linit={entrevista.caducidad_linit}
                    carnet_conducir_vigente={entrevista.carnet_conducir_vigente}
                    caducidad_carnet={entrevista.caducidad_carnet}
                    como_llego_cv={entrevista.como_llego_cv}
                    forma_de_comunicarse={entrevista.forma_de_comunicarse}
                    tiempo_de_incorporacion={entrevista.tiempo_de_incorporacion}
                    algun_conocido={entrevista.algun_conocido}
                    situacion_familiar={entrevista.situacion_familiar}
                    user={entrevista.user}
                    remuneracion_pretendida={entrevista.remuneracion_pretendida}
                    referencias_laborales={entrevista.referencias_laborales}
                    puestoQueAplica={puestoQueAplica}
                    obtenerEntrevistas={searchEntrevistasPorCandidato}
                    mostrarAlertaTemporal={mostrarAlertaTemporal}
                    tipo_entrevista_desplegable={
                      entrevista.tipo_entrevista_desplegable
                    }
                    tipo_entrevista={entrevista.tipo_entrevista}
                  />
                ))}
              </Box>
            </>
          )}
        </Box>
      </Modal>
    </>
  );
};

export default Entrevistas;
